<template>
  <v-container>
    <v-row>
      <v-col
        cols="12"
        class="text-center mt-12"
      >
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
  export default {
    name: 'LoadData',
  }
</script>
